export const DEFAULT_ATTRS: Attrs = {
	bgcolor: '#fff',
	value: '',
	minified: '',
};

export type Attrs = {
	readonly bgcolor: string;
	readonly value: string;
	readonly minified: string;
};

export type SetAttrs = ( attrs: Partial< Attrs > ) => void;
